import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Warm%20abstract%20organic%20natural%20landscape%20with%20soft%20rolling%20hills%20in%20earthy%20amber%20and%20olive%20green%20tones%2C%20gentle%20morning%20light%2C%20artistic%20illustration%20style%2C%20dreamy%20atmosphere%2C%20clean%20minimal%20composition%2C%20warm%20gradient%20sky%2C%20no%20buildings%20or%20people&width=1800&height=1000&seq=hero-bg-2026&orientation=landscape)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-5 leading-tight">
          发现志同道合的伙伴
          <br />
          <span className="text-primary-300">探索精彩世界</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
          蘑菇社区是一个充满活力的兴趣交流平台，汇聚海量优质内容与真实用户分享。
          加入我们，让每一次社区体验都温暖有趣。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-base font-medium whitespace-nowrap transition-colors cursor-pointer"
          >
            立即加入蘑菇社区
          </Link>
          <Link
            to="/category/travel"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white rounded-lg text-base font-medium whitespace-nowrap transition-colors cursor-pointer"
          >
            探索兴趣圈子
          </Link>
        </div>

        <div className="flex items-center justify-center gap-6 mt-10">
          {[
            { num: '18万+', label: '活跃用户' },
            { num: '1.2万+', label: '优质文章' },
            { num: '6大类', label: '兴趣圈子' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">
                {stat.num}
              </div>
              <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}